<div class="auth-layout" [class.auth-layout--split]="isSplit">
  <div class="auth-layout__column">
    <!-- The scene is a CSS background (mobile / desktop artwork, see the scss) so only the
         one that applies is downloaded. -->
    <div
      class="auth-layout__hero"
      [class.auth-layout__hero--with-copy]="hasHeroCopy"
      [class.auth-layout__hero--short]="shortHero && !hasHeroCopy"
      [class.auth-layout__hero--registration-complete]="heroArt === 'registration-complete'"
      aria-hidden="true"
    ></div>

    <div class="auth-layout__logo-row">
      <img
        class="auth-layout__logo-icon"
        src="assets/plan/Happy-Plan-Doodat.png"
        alt=""
        aria-hidden="true"
      />
      <img class="auth-layout__logo-wordmark" src="assets/logo/logo-flip-text.svg" alt="flip*" />
    </div>

    <!-- Optional per-screen tagline over the hero (Figma "Live more. Hurt less."). -->
    <div class="auth-layout__hero-copy" *ngIf="hasHeroCopy">
      <p class="auth-layout__hero-title" *ngIf="heroTitle || heroAccent">
        <span *ngIf="heroTitle" class="auth-layout__hero-line">{{ heroTitle }}</span>
        <span *ngIf="heroAccent" class="auth-layout__hero-line auth-layout__hero-line--accent">{{ heroAccent }}</span>
      </p>
    </div>

    <!-- Desktop split layout only (hidden below the breakpoint): the headline over the hero scene. The
         page's own heading carries the meaning, so this is decorative. -->
    <p class="auth-layout__headline" *ngIf="isSplit" aria-hidden="true">
      <span
        *ngFor="let part of desktopHeadline"
        [class.auth-layout__headline-accent]="part.accent"
        >{{ part.text }}</span
      >
      <span class="auth-layout__headline-subtitle" *ngIf="heroSubtitle">{{ heroSubtitle }}</span>
    </p>

    <div class="auth-layout__panel" [class.auth-layout__panel--plain]="!panelBackground">
      <ng-content></ng-content>
    </div>

    <!-- Footer scene: a CSS background too (mobile / desktop artwork, see the scss). -->
    <div
      class="auth-layout__footer"
      [class.auth-layout__footer--plain]="!panelBackground"
      aria-hidden="true"
    ></div>
  </div>
</div>
